'use strict';
define([], function () {
    function SEOCheckerCtrl($scope, AuthService) {
        $scope.authenticated = AuthService.isAuthenticated();
    }

    SEOCheckerCtrl.$inject = ['$scope', 'AuthService'];
    return SEOCheckerCtrl;
});
